export default __webpack_public_path__ + "static/media/1.db6c72e8.png";